import React from 'react';
import PropTypes from 'prop-types';

import { FormTop, FormBottom } from '../SharedSC/FormSC';

import {
  Column,
  ElevatedForm,
  CancelButton,
  SubmitButton,
  TextFieldWithError
} from '../../Forms/FormComponents';

const InstitutionIdTypeForm = ({
  institutionIdType,
  entityLabel,
  buttonText,
  handleChange,
  onSubmit,
  showValidationErrors,
  validateName,
  onFormClose
}) => (
  <ElevatedForm>
    <FormTop>
      <Column size="100%">
        <TextFieldWithError
          id="institutionIdTypeName"
          name="name"
          value={institutionIdType.name}
          onChange={event => handleChange(event)}
          margin="normal"
          InputLabelProps={{ shrink: true }}
          label={`${entityLabel}*`}
          placeholder=""
          variant="outlined"
          validate={validateName}
          showValidationErrors={showValidationErrors}
        />
      </Column>
    </FormTop>
    <FormBottom>
      <CancelButton onClick={onFormClose} noHoverBg>
        Cancel
      </CancelButton>
      <SubmitButton onClick={onSubmit}>{buttonText}</SubmitButton>
    </FormBottom>
  </ElevatedForm>
);

InstitutionIdTypeForm.propTypes = {
  institutionIdType: PropTypes.object,
  buttonText: PropTypes.string,
  entityLabel: PropTypes.string,
  showValidationErrors: PropTypes.bool,
  handleChange: PropTypes.func,
  onSubmit: PropTypes.func,
  validateName: PropTypes.func.isRequired,
  onFormClose: PropTypes.func
};
InstitutionIdTypeForm.defaultProps = {
  institutionIdType: {},
  buttonText: 'Create',
  entityLabel: 'Type',
  showValidationErrors: false,
  handleChange: undefined,
  onSubmit: undefined,
  onFormClose: undefined
};

export default InstitutionIdTypeForm;
